module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ed-search-bar"
  }, [_c('input', {
    staticClass: "ed-search-bar__input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.emitFunction($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ed-search-bar__addon",
    on: {
      "click": _vm.emitFunction
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c1b058f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/edoc-library/src/components/searchBar/searchBar.vue
// module id = 706
// module chunks = 42